import { render, staticRenderFns } from "./complain.vue?vue&type=template&id=c1adbe48&"
import script from "./complain.vue?vue&type=script&lang=js&"
export * from "./complain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports